import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import classNames from 'classnames';

const TabsNavItem = /*#__PURE__*/ React__default.forwardRef(({ selected, children, ...props }, ref)=>{
    return jsx("a", {
        ref: ref,
        className: classNames('cb-tabs-nav-item', {
            selected
        }),
        ...props,
        children: children
    });
});
TabsNavItem.displayName = 'TabsNav.Item';

export { TabsNavItem, TabsNavItem as default };
//# sourceMappingURL=TabsNav.Item.es.js.map
